/*
 * Copyright © 2021 Firecrest Clinical, Ltd.
 * All rights reserved.
 */

import {TemplateRef} from '@angular/core';
import {SafeHtml} from '@angular/platform-browser';
import {Observable} from 'rxjs';
import {FcAgContextMenuOptions} from '../fc-ag-context/fc-ag-context-menu.component';

export interface FcResponsiveAgGridColumn {
    colClass?: string,
    isHidden?: () => boolean,
    label?: string,
    field?: string,
    enableHtml?: boolean,
    width?: number,
    cellTemplate?: TemplateRef<any>,
    disableSort?: boolean,
    renderCell?: (item: any, column: FcResponsiveAgGridColumn, options: FcResponsiveAgGridOptions) => string|SafeHtml,
    cellClick?: (event: any, item: any, column: FcResponsiveAgGridColumn, options: FcResponsiveAgGridOptions) => void
}

export interface FcResponsiveAgGridOptions {
    isExpand?: boolean,
    rowDetailsTemplate?: any,
    iconField?: string,
    isMobileMode?: boolean,
    mobileWidth?: number,
    data?: any[],
    allData?: any[],
    selectedList?: any[],
    globalSelectedList?: any[],
    isKeepSelectedList?: boolean,
    compareKey?: string,
    dataLength?: number,
    columnDefs: FcResponsiveAgGridColumn[],
    pageSizeList?: number[],
    enableSort?: boolean,
    enablePagination?: boolean,
    serverSort?: boolean,
    serverPagination?: boolean,
    multipleSelect?: boolean,
    isCheckAllDisabled?: boolean,
    isCheckAllHidden?: boolean,
    isDropDownOpen?: boolean,
    gridState?: {
        order?: string,
        orderBy?: string,
        pageSize?: number,
        currentPage?: number
    },
    contextCfg?: FcAgContextMenuOptions,
    extendOptions?: any,
    getGridData: (context?: any) => Observable<{data: any[], dataLength: number}>,
    setGridData?: (context?: any) => void,
    showContextMenu?: (event: any, dataItem: any) => void,
    hideContextMenu?: (dataItem: any) => boolean,
    cellClick?: (event: any, item: any, column: FcResponsiveAgGridColumn, options: FcResponsiveAgGridOptions) => void,
    rowClick?: (event: any, item: any, options: FcResponsiveAgGridOptions) => void,
    renderCell?: (item: any, column: FcResponsiveAgGridColumn, options: FcResponsiveAgGridOptions) => string|SafeHtml,
    sortChange?: (column: FcResponsiveAgGridColumn) => void,
    pageSizeChange?: (currentPageSize: number) => void,
    sortDataUI?: () => void,
    toggleAll?: () => void,
    isAllSelected?: () => boolean,
    getPageNumbers?: () => number[],
    showPage?: (currentPage: number) => void,
    getPageDetail?: () => string,
    getNumberExtraRows?: () => number[]
}